// The config key a replayed request is marked with, so that a second failure
// is recognisable as one.
export const RETRY_FLAG = 'isTokenRefreshRetry'

// What a failed request can have earned. `chooseRecovery()` picks one and the
// response interceptor carries it out.
export const ABANDON = 'abandon'
export const PASS_THROUGH = 'pass-through'
export const REFRESH = 'refresh'
export const REPLAY = 'replay'
